import Label from "components/label";
import useProfile from "state/useProfile";

const LabelPackage = () => {
  const { userPackage } = useProfile();
  const color = userPackage.colorLabelPackage();

  return (
    <Label variant="filled" sx={{ color: color, backgroundColor: color+"14" }}>
      {userPackage.nameLabelPackage()}
    </Label>
  );
};

export default LabelPackage;
